import { functions } from '@/modules/firebase'
import { httpsCallable } from 'firebase/functions'

export const getRandomName = httpsCallable<
  { userId: string },
  { randomName: string }
>(functions, 'getRandomName')
